module.exports = __webpack_public_path__ + "img/涉密信息系统集成乙级资质证书.ea8f9c23.png";